<div class="info-card">
  <div class="info-card__content">
    <ng-content />
  </div>
  <div class="info-card__context-info">
    <ng-content select="[info-card-context]" />
  </div>
</div>
